import PropTypes from 'prop-types';
import { YES_FLAG, NO_FLAG } from './constants';

export const allProvisionsPropTypes = PropTypes.arrayOf(PropTypes.shape({
  companyCode: PropTypes.string,
  ccDescription: PropTypes.string,
}));
export const provisionsProcessedSuccessfullyPropTypes = PropTypes.arrayOf(PropTypes.shape({
  companyCode: PropTypes.string,
  ccDescription: PropTypes.string,
  legalEntity: PropTypes.string,
  countryName: PropTypes.string,
  updatedOn: PropTypes.string,
  statusName: PropTypes.string,
}));
export const provisionsTrialBalancesNotReceivedPropTypes = PropTypes.arrayOf(PropTypes.shape({
  companyCode: PropTypes.string,
  ccDescription: PropTypes.string,
  legalEntity: PropTypes.string,
  countryName: PropTypes.string,
  statusName: PropTypes.string,
}));
export const provisionsTrialBalancesWithErrorsPropTypes = PropTypes.arrayOf(PropTypes.shape({
  companyCode: PropTypes.string,
  ccDescription: PropTypes.string,
  legalEntity: PropTypes.string,
  countryName: PropTypes.string,
  importResults: PropTypes.string,
  importStatus: PropTypes.string,
}));
export const provisionsCalculationsWithErrorsPropTypes = PropTypes.arrayOf(PropTypes.shape({
  companyCode: PropTypes.string,
  ccDescription: PropTypes.string,
  legalEntity: PropTypes.string,
  countryName: PropTypes.string,
  importStatus: PropTypes.string,
}));
export const provisionsOtherErrorsPropTypes = PropTypes.arrayOf(PropTypes.shape({
  connectionName: PropTypes.string,
  companyCode: PropTypes.string,
  notes: PropTypes.string,
}));
export const journalsPropTypes = PropTypes.arrayOf(PropTypes.shape({
  account: PropTypes.string,
  accountDesc: PropTypes.string,
  bookType: PropTypes.string,
  calcJobId: PropTypes.number,
  companyCode: PropTypes.string,
  connName: PropTypes.string,
  costCenter: PropTypes.string,
  currency: PropTypes.string,
  dateCreated: PropTypes.string,
  description: PropTypes.string,
  endDate: PropTypes.string,
  enteredCR: PropTypes.number,
  enteredDR: PropTypes.number,
  function: PropTypes.string,
  future1: PropTypes.string,
  future2: PropTypes.string,
  geography: PropTypes.string,
  journalEntryReveralPeriod: PropTypes.string,
  journalEntryReversalFlag: PropTypes.string,
  ledgerId: PropTypes.number,
  periodName: PropTypes.string,
  productLine: PropTypes.string,
  projectCode: PropTypes.string,
  provisionCompanyCode: PropTypes.string,
  reference: PropTypes.string,
  tradingPartner: PropTypes.string,
}));

export const localJournalsPropTypes = PropTypes.arrayOf(PropTypes.shape({
  periodName: PropTypes.string,
  provisionLE: PropTypes.string,
  provisionME: PropTypes.string,
  legalEntity: PropTypes.string,
  managementEntity: PropTypes.string,
  companyCode: PropTypes.string,
  localAccount: PropTypes.string,
  ile: PropTypes.string,
  ime: PropTypes.string,
  currency: PropTypes.string,
  enteredDR: PropTypes.number,
  enteredCR: PropTypes.number,
  description: PropTypes.string,
  localAccountDescription: PropTypes.string,
  bookType: PropTypes.string,
}));

export const journalsDetailPropTypes = PropTypes.arrayOf(PropTypes.shape({
  companyCode: PropTypes.string,
  bookType: PropTypes.string,
  plAccount: PropTypes.string,
  tradingPartner: PropTypes.string,
  costCenter: PropTypes.string,
  description: PropTypes.string,
  accountDesc: PropTypes.string,
}));

export const listItemPropTypes = PropTypes.shape({
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
});

export const categoryPropTypes = PropTypes.shape({
  categoryName: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
});

export const confirmModalDataPropTypes = PropTypes.shape({
  show: PropTypes.bool,
  data: PropTypes.shape({
    onConfirm: PropTypes.func.isRequired,
    ssoToBeSelected: PropTypes.string,
  }),
});

export const requiredWhenPresent = (fieldsToCheck, basePropType) => (props, propName, componentName) => {
  const arePresent = fieldsToCheck.reduce((result, field) => result && props[field], true);
  if (arePresent) {
    return PropTypes.checkPropTypes({ [propName]: basePropType.isRequired }, props, propName, componentName);
  }
  return PropTypes.checkPropTypes({ [propName]: basePropType }, props, propName, componentName);
};

export const yesNoFlagPropTypes = PropTypes.oneOf([YES_FLAG, NO_FLAG]);
